import styled from "styled-components";

import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const StyledToggleRow = styled(FlexRow)`
    align-items: center;
    gap: 8px;
`;

export const StyledDescription = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
`;
